/**
 * Labstep
 *
 * @module components/ProtocolCondition/Explorer/EmptyState
 * @desc Empty state for ProtocolConditionExplorer
 */

import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';

export const ProtocolConditionExplorerEmptyState: React.FC = () => (
  <CardEmptyState
    src="/img/empty-state/inventory.svg"
    title="No Data Found"
    explanation="We couldn't find any experiments using this protocol."
  />
);
